import D2PLMD1010 from '@/views/PLM/D2PLMD1010.js'

/**
 * @file 配車表入力(ドリームロード)
 * 検索後に表示される運行日(範囲指定時)をyyyy/mm/ddで表示する
 */
export default {
  extends: D2PLMD1010,
  name: 'HaishaMeisaiListEditCustomForDld',
  watch: {
    // 運行日From
    'conditions.sagyoYoteiYmdFrom': function () {
      this.conditions.unkoYmdFromTo = this.computedUnkoYmdFromToDld()
    },
    // 運行日To
    'conditions.sagyoYoteiYmdTo': function () {
      this.conditions.unkoYmdFromTo = this.computedUnkoYmdFromToDld()
    }
  },
  methods: {
    computedUnkoYmdFromToDld: function () {
      const from = ![undefined, null, ''].includes(this.conditions.sagyoYoteiYmdFrom) ? this.conditions.sagyoYoteiYmdFrom : ''
      const to = ![undefined, null, ''].includes(this.conditions.sagyoYoteiYmdTo) ? this.conditions.sagyoYoteiYmdTo : ''
      return from + (to ? '～' + to : '')
    },
    initBindVariables: function () {
      D2PLMD1010.methods.initBindVariables.call(this)
      this.conditions.unkoYmdFromTo = this.computedUnkoYmdFromToDld()
    }
  }
}
